import { callable } from '../callable';

export type MaterialType = 'video' | 'notes' | 'reading';
export type ExternalSource = 'zoom' | 'youtube' | 'vimeo' | 'other';

export interface SectionMaterialDto {
  id: string;
  type: MaterialType;
  title: string;
  description?: string;
  storagePath?: string;
  downloadUrl?: string;
  mimeType?: string;
  sizeBytes?: number;
  originalFileName?: string;
  url?: string;
  externalSource?: ExternalSource;
  sortOrder: number;
  publishedAt: string;
}

export interface CreateCourseMaterialRequest {
  tenantId: string;
  sectionId: string;
  type: MaterialType;
  title: string;
  description?: string;
  storagePath?: string;
  downloadUrl?: string;
  mimeType?: string;
  sizeBytes?: number;
  originalFileName?: string;
  url?: string;
  externalSource?: ExternalSource;
}

export const courseMaterialApi = {
  create: async (data: CreateCourseMaterialRequest): Promise<{ id: string }> => {
    const fn = callable<CreateCourseMaterialRequest, { id: string }>('createCourseMaterial');
    const res = await fn(data);
    return res.data;
  },

  update: async (data: {
    tenantId: string;
    materialId: string;
    title?: string;
    description?: string;
    sortOrder?: number;
    type?: MaterialType;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('updateCourseMaterial');
    const res = await fn(data);
    return res.data;
  },

  delete: async (data: { tenantId: string; materialId: string }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('deleteCourseMaterial');
    const res = await fn(data);
    return res.data;
  },

  list: async (data: {
    tenantId: string;
    sectionId: string;
    requestingStudentId?: string;
  }): Promise<{ items: SectionMaterialDto[] }> => {
    const fn = callable<typeof data, { items: SectionMaterialDto[] }>('listSectionMaterials');
    const res = await fn(data);
    return res.data;
  },

  getDownloadUrl: async (data: {
    tenantId: string;
    materialId: string;
    requestingStudentId?: string;
  }): Promise<{ url: string; expiresInSeconds: number }> => {
    const fn = callable<typeof data, { url: string; expiresInSeconds: number }>(
      'getCourseMaterialDownloadUrl',
    );
    const res = await fn(data);
    return res.data;
  },
};
